// extracted by mini-css-extract-plugin
export default {"imgdiv":"b0d4251f7d _9fb19fa064","img":"ac03593de1 e59a4c757c"};